import DefinitionBracket from './DefinitionBracket.vue'
import DefinitionNode from './DefinitionNode.vue'
import DefinitionOperator from './DefinitionOperator.vue'
import DefinitionNodeDropZone from './DefinitionNodeDropZone.vue'

export default {
  functional: true,
  props: {
    definition: {
      type: Array,
      required: true
    },
    enableDragAndDrop: {
      type: Boolean,
      default: false
    },
    isDraggingPart: {
      type: Boolean,
      default: false
    }
  },
  render (h, context) {
    const renderThis = flattenedDefinitionComponents(h, context.props.definition, context.props.enableDragAndDrop)
    if (context.props.enableDragAndDrop && context.props.isDraggingPart) {
      renderThis.push(h(DefinitionNodeDropZone))
    }
    return h('div', {
      attrs: {
        id: 'target-definition-statement',
        class: 'target-definition-statement'
      },
      style: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center'
      }
    }, renderThis)
  }
}

function flattenedDefinitionComponents (h, definition, enableDragAndDrop) {
  let level = 0
  const reducer = (acc, attr, index, arr) => {
    if (attr.type || attr.id && attr.value) {
      acc.push(
        h(DefinitionNode, {
          props: {
            definitionId: attr.definitionId,
            attribute: attr,
            inGroup: level > 0,
            isFirst: index === 0,
            isLast: index === arr.length - 1,
            isDraggable: enableDragAndDrop,
            level
          }
        })
      )
    }

    if (attr.children) {
      level++
      const isSuperGroup = attr.children.filter(a => a.children).length
      // add left bracket
      acc.push(isSuperGroup ? createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: DefinitionBracket.DIRECTION.left,
        bracketType: DefinitionBracket.BRACKET_TYPE.square,
        attribute: attr,
        isDraggable: enableDragAndDrop,
        level
      }) : createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: DefinitionBracket.DIRECTION.left,
        isDraggable: enableDragAndDrop,
        attribute: attr,
        level
      }))
      // build group children
      acc.concat(attr.children.reduce(reducer, acc))
      // add right bracket
      acc.push(isSuperGroup ? createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: DefinitionBracket.DIRECTION.right,
        bracketType: DefinitionBracket.BRACKET_TYPE.square,
        attribute: attr,
        isDraggable: enableDragAndDrop,
        level
      }) : createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: DefinitionBracket.DIRECTION.right,
        attribute: attr,
        isDraggable: enableDragAndDrop,
        level
      }))
      level--
    }

    if (attr.operator) {
      acc.push(h(DefinitionOperator, {
        props: {
          definitionId: attr.definitionId,
          operator: attr,
          isDraggable: enableDragAndDrop,
          level
        }
      }))
    }

    return acc
  }
  return definition.reduce(reducer, [])
}

function createBracketIcon (h, {definitionId, direction, bracketType = DefinitionBracket.BRACKET_TYPE.normal, attribute, isDraggable, level}) {
  return h(DefinitionBracket, {
    props: {
      definitionId,
      direction,
      bracketType,
      attribute,
      isDraggable,
      level
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/appComponents/oldWorkbench/targetDefinition/targetDefinitionStatement/index.js